import React, { Component } from "react";
import { Field, reduxForm, formValueSelector, change } from "redux-form";
import { bindActionCreators } from "redux";
import { Tabs, Tab } from "material-ui/Tabs";
import {
	TextField,
	SelectField as RFSelectField
} from "redux-form-material-ui";
import { Card, CardText } from "material-ui/Card";
import { connect } from "react-redux";
import { MenuItem, RaisedButton, FlatButton } from "material-ui";
import moment from "moment";
import _ from "lodash";
import download from "downloadjs";
import {
	actionGetProvinces,
	actionGetCities
} from "../../actions/ProvinceActions";
import {
	actionCreateAfiliado,
	actionUpdateAfiliado,
	actionChangeAfiliadoProps,
	actionGetContributions,
	actionGenerateAffiliateCard,
	asyncCheckCuil,
	actionCheckContriByCUIL
} from "../../actions/AfiliadoActions";
import {
	actionUploadFile,
	actionDeleteImage
} from "../../actions/MediaActions";
import {
	actionGetCivilStatusList,
	actionGetGendersList,
	actionGetNationalitiesList,
	actionGetRelationshipList
} from "../../actions/DataActions";
import {
	required,
	requiredNoUnderscore,
	onKeyPressLetterAndSpaceOnly
} from "../../common/validaciones";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import { AFILIADOS } from "../../config/RoutesConstants";
import Util, { SUCCESS, ERROR } from "../../common/Util";
import UtilPC from "../../common/UtilPC";
import InputMask from "../../components/InputMask/InputMask";
import "./Afiliados.css";
import {
	PERSONA_IMPORTADO,
	PERSONA_VERIFICAR,
	PERSONA_VERIFICADO,
	ROL_ADMIN,
	ROL_OPERADOR_RECAUDA,
	ROL_SUB_ADMIN
} from "../../common/Constants";
import AppMem from "../../common/AppMem";
import FamilityTab from "./Tabs/FamilityTab";
import MembershipTab from "./Tabs/MembershipTab";
import ContributionsTab from "./Tabs/ContributionsTab";
import PersonalTab from "./Tabs/PersonalTab";

let _handleSubmitFail;
let values2 = {};
let valueInitialPhotoPath = "none";
let valueInitialPhoto = "none";
let card = false;
class AfiliadoForm extends Component {
	constructor(props) {
		super(props);
		let state =
			this.props.modeCRU === MODE_CRU_CREATE
				? this.returnStateNewAfiliado()
				: this.props.modeCRU === MODE_CRU_UPDATE
					? this.returnStateEditAfiliado()
					: this.returnStateShowAfiliado();
		this.state = state;
		this.initializeValues = this.initializeValues.bind(this);
		this.returnOnSubmit = this.returnOnSubmit.bind(this);
		this.returnDownload = this.returnDownload.bind(this);
		this.changeAfiliadoProps = this.changeAfiliadoProps.bind(this);
		_handleSubmitFail = this.changeTabOnSubmitFail.bind(this);
		this.dispatchOnChange = this.dispatchOnChange.bind(this);
	}

	changeTabOnSubmitFail() {
		this.setState({ currentTab: "c" });
	}

	componentWillMount() {
		if (!this.props.modeCRU) {
			this.props.history.push(AFILIADOS);
		} else {
			this.props.actionGetProvinces();
			this.props.actionGetCivilStatusList();
			this.props.actionGetGendersList();
			this.props.actionGetNationalitiesList();
			this.props.actionGetRelationshipList();
		}
	}

	componentDidMount() {
		if (this.props.modeCRU !== MODE_CRU_CREATE) this.initializeValues(false);
	}

	componentWillUnmount() {
		values2 = {};
		valueInitialPhotoPath = "none";
		valueInitialPhoto = "none";
		card = false;
		this.props.actionChangeAfiliadoProps({
			photoChange: false
		});
	}
	componentWillReceiveProps(nextProps) {
		let formValues = this.props.formValues;
		if (
			nextProps.afiliado &&
			!_.isEqual(nextProps.afiliado.status, formValues.status)
		) {
			this.dispatchOnChange("status", nextProps.afiliado.status);
		}
	}
	returnStateShowAfiliado() {
		return {
			enableField: true,
			province: null,
			currentTab: "a",
			contributionsList: false,
			personPhoto: false
		};
	}

	returnStateNewAfiliado() {
		return {
			disableCity: true,
			province: null,
			currentTab: "a",
			personPhoto: false
		};
	}

	returnStateEditAfiliado() {
		return {
			disabledCity: false,
			province: null,
			currentTab: "a",
			contributionsList: false,
			personPhoto: false
		};
	}

	initializeValues(flag) {
		if (!flag) {
			card = false;
			let person = this.props.afiliado.person;
			let afiliado = this.props.afiliado;
			if (person.city) this.props.actionGetCities(person.city.province.id);
			values2 = afiliado;
			valueInitialPhotoPath = afiliado.person.photoPath;
			valueInitialPhoto = afiliado.person.photo;
			this.props.initialize({
				...afiliado,
				person: {
					...person,
					cuil: person.cuil.toString()
				}
			});
		} else {
			values2 = {};
			valueInitialPhotoPath = "none";
			valueInitialPhoto = "none";
			card = false;
		}
	}

	onSubmit(formValues) {
		let values = Object.assign({}, formValues);
		values.person = Object.assign({}, formValues.person);
		values2 = values;
		let path = "afiliado/photos";
		let type = this.props.cameraPhoto ? "imageEncode64" : "image";
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			if (values.person.photo) {
				//Tiene foto sube y crea el afiliado
				this.props.actionUploadFile(
					values.person.photo,
					path,
					type,
					this.props.firebaseToken,
					this.returnGoToCreateOrUpdateAfiliado.bind(this)
				);
			} else {
				//No tiene foto, cre el afiliado simplemente
				this.props.actionCreateAfiliado(values, this.returnOnSubmit);
			}
		} else if (this.props.modeCRU === MODE_CRU_UPDATE) {
			//Mode Crud Update
			values.id = this.props.afiliado.id;
			values2.ud = this.props.afiliado.id;
			if (values.person.photo) {
				if (this.props.photoChange && valueInitialPhoto != null) {
					//Tiene foto, y se cambio la foto
					this.props.actionDeleteImage(
						values.person.photoPath,
						this.props.firebaseToken,
						this.returnToDeletePhotoAfiliado.bind(this, values.person.photo)
					);
				} else if (valueInitialPhoto !== values.person.photo) {
					this.props.actionUploadFile(
						values.person.photo,
						path,
						type,
						this.props.firebaseToken,
						this.returnGoToCreateOrUpdateAfiliado.bind(this)
					);
				} else {
					if (card) {
						this.props.actionGenerateAffiliateCard(values, this.returnDownload);
					}
					//NO cambio la foto, pero sigue teniendo foto
					else this.props.actionUpdateAfiliado(values, this.returnOnSubmit);
				}
			} else if (
				this.props.photoChange ||
				(valueInitialPhoto !== null && valueInitialPhotoPath !== null)
			) {
				//hacer un delete y modificar el afiliado, no tiene foto al final
				values.person.photo = null;
				values.person.photoPath = null;
				this.props.actionDeleteImage(
					valueInitialPhotoPath,
					this.props.firebaseToken,
					this.createOrUpdateAfiliado.bind(this, values)
				);
			} else {
				if (card) {
					this.props.actionGenerateAffiliateCard(values, this.returnDownload);
				}
				//Update sin modificar foto y sin foto
				else this.props.actionUpdateAfiliado(values, this.returnOnSubmit);
			}
		}
		//aca deberia ir generar Credencial
	}
	createOrUpdateAfiliado(values) {
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			this.props.actionCreateAfiliado(values, this.returnOnSubmit);
		} else {
			if (card)
				this.props.actionGenerateAffiliateCard(values, this.returnDownload);
			else this.props.actionUpdateAfiliado(values, this.returnOnSubmit);
		}
	}
	returnToDeletePhotoAfiliado(photo2) {
		let path = "afiliado/photos";
		let type = this.props.cameraPhoto ? "imageEncode64" : "image";
		this.props.actionUploadFile(
			photo2,
			path,
			type,
			this.props.firebaseToken,
			this.returnGoToCreateOrUpdateAfiliado.bind(this)
		);
	}
	returnGoToCreateOrUpdateAfiliado(URLPhoto, path) {
		values2.person.photoPath = path;
		values2.person.photo = URLPhoto;
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			this.props.actionCreateAfiliado(values2, this.returnOnSubmit);
		} else {
			if (card) {
				this.props.actionGenerateAffiliateCard(values2, this.returnDownload);
			} else this.props.actionUpdateAfiliado(values2, this.returnOnSubmit);
		}
	}
	returnOnSubmit(response) {
		if (response === SUCCESS) {
			if (this.props.modeCRU === MODE_CRU_CREATE) {
				this.props.actionChangeAfiliadoProps({
					photoChange: false
				});
				Util.showNoty(SUCCESS, "Afiliado creado exitosamente");
				AppMem.infoDialog.open({
					title: "Información",
					messageConfirm: `Numero de afiliado: ${
						this.props.afiliado.affiliateNumber
					}`,
					onAccept: () => this.props.history.push(AFILIADOS)
				});
			} else if (this.props.modeCRU === MODE_CRU_UPDATE) {
				this.props.actionChangeAfiliadoProps({
					photoChange: false
				});
				Util.showNoty(SUCCESS, "Afiliado modificado exitosamente");
				this.props.history.push(AFILIADOS);
			}
		}
	}
	returnDownload(blob) {
		if (blob === false) {
			Util.showNoty(
				ERROR,
				"El Afiliado debe estar Activo, tener aportes y una foto para generar la credencial."
			);
		} else {
			let fechaActual = moment().format("DD-MM-YYYY");
			let nombreArchivo = "AffiliateCard - " + fechaActual;
			download(blob, nombreArchivo);
			Util.showNoty(SUCCESS, "La credencial ha sido generada con éxito");
			this.props.history.push(AFILIADOS);
		}
	}
	dispatchOnChange(field, value) {
		this.props.dispatch(change("AfiliadoForm", field, value));
	}
	handleChange = value => {
		let cl = false;
		if (value === "d" && this.state.contributionsList === false) {
			cl = true;
			this.props.actionGetContributions(this.props.afiliado.affiliateNumber);
			this.setState({
				currentTab: value,
				contributionsList: cl
			});
		} else {
			this.setState({
				currentTab: value
			});
		}
	};
	changeAfiliadoProps(generateCard) {
		return new Promise(async (resolve, reject) => {
			card = generateCard;
			resolve();
		});
	}
	checkContriByCUIL() {
		this.props.actionCheckContriByCUIL(this.props.formValues.person.cuil);
	}
	render() {
		const { handleSubmit, rol, modeCRU } = this.props;
		const disabled = rol === ROL_OPERADOR_RECAUDA && modeCRU === MODE_CRU_SHOW;
		return (
			<div className="center">
				<Card className="card">
					{UtilPC.renderCardTitleCRU(modeCRU, "Afiliado")}
					<CardText>
						<form>
							<div className="content-papercard">
								<div className="columns-row-between bottom35">
									<Field
										name="person.cuil"
										style={{ marginRight: 15 }}
										component={InputMask}
										floatingLabelText="CUIL"
										validate={[requiredNoUnderscore]}
										parse={Util.formatCuitToNumber}
										disabled={disabled}
										mask={[
											/\d/,
											/\d/,
											"-",
											/\d/,
											/\d/,
											/\d/,
											/\d/,
											/\d/,
											/\d/,
											/\d/,
											/\d/,
											"-",
											/\d/
										]}
										floatingLabelFixed={modeCRU !== MODE_CRU_CREATE}
									/>
									<Field
										name="person.surname"
										style={{ marginRight: 15 }}
										component={TextField}
										floatingLabelText="Apellidos"
										validate={required}
										onKeyPress={onKeyPressLetterAndSpaceOnly}
										disabled={
											rol === ROL_OPERADOR_RECAUDA || modeCRU === MODE_CRU_SHOW
												? true
												: false
										}
									/>
									<Field
										name="person.name"
										style={{ marginRight: 15 }}
										component={TextField}
										floatingLabelText="Nombre"
										validate={required}
										onKeyPress={onKeyPressLetterAndSpaceOnly}
										disabled={disabled}
									/>
									<Field
										name="affiliateNumber"
										style={{ marginRight: 15 }}
										component={TextField}
										floatingLabelText="Nro. de afiliado"
										disabled
										onChange={event => event.preventDefault()}
									/>
									<Field
										name="person.status"
										component={RFSelectField}
										floatingLabelText="Estado"
										disabled={disabled}
									>
										<MenuItem
											key={1}
											value={PERSONA_VERIFICADO}
											primaryText={PERSONA_VERIFICADO}
											disabled={
												rol === ROL_ADMIN || rol === ROL_SUB_ADMIN
													? false
													: true
											}
										/>
										<MenuItem
											key={2}
											value={PERSONA_IMPORTADO}
											primaryText={PERSONA_IMPORTADO}
											disabled
										/>
										<MenuItem
											key={3}
											value={PERSONA_VERIFICAR}
											primaryText={PERSONA_VERIFICAR}
										/>
									</Field>
								</div>
								<Tabs
									value={this.state.currentTab}
									onChange={this.handleChange}
								>
									<Tab label="Datos personales" value="a">
										<PersonalTab />
									</Tab>
									<Tab label="Datos Afiliación" value="b">
										<MembershipTab
											onSubmitGenerateCard={handleSubmit(
												this.onSubmit.bind(this)
											)}
											changeAfiliadoProps={this.changeAfiliadoProps}
											personPhoto={
												this.state.personPhoto ? this.state.personPhoto : false
											}
											dispatchOnChange={this.dispatchOnChange}
										/>
									</Tab>
									<Tab label="Familiares" value="c">
										<FamilityTab
											relationshipsListArray={this.props.relationshipList}
										/>
									</Tab>
									<Tab label="Aportes" value="d">
										<ContributionsTab
											contributionsList={this.props.contributionsList}
											checkContriByCUIL={this.checkContriByCUIL.bind(this)}
											personCuil={
												this.props.formValues.person
													? this.props.formValues.person.cuil
													: null
											}
											onOpenAddSalary={() => {
												this.props.dispatch(
													change(
														"AddSalaryDialogForm",
														"affiliateNumber",
														this.props.afiliado.affiliateNumber
													)
												);
											}}
											affiliateNumber={
												!MODE_CRU_CREATE
													? this.props.afiliado.affiliateNumber
													: null
											}
										/>
									</Tab>
								</Tabs>
							</div>
							<div className="top20 text-right">
								<FlatButton
									label="Cancelar"
									onClick={() => this.props.history.push(AFILIADOS)}
									style={{ margin: 5 }}
								/>
								{this.props.modeCRU !== MODE_CRU_SHOW ? (
									<RaisedButton
										label="Aceptar"
										disabled={this.state.cantSubmit}
										primary
										style={{ margin: 5 }}
										onClick={handleSubmit(this.onSubmit.bind(this))}
									/>
								) : null}
							</div>
						</form>
					</CardText>
				</Card>
			</div>
		);
	}
}
const asyncValidate = (values, dispatch, props, currentFieldName) => {
	if (currentFieldName === "person.cuil") {
		let cuil = values.person.cuil;
		return asyncCheckCuil(cuil).then(response => {
			if (response !== null) {
				if (_.size(response) >= 1 && !response.affiliateNumber) {
					AppMem.infoDialog.open({
						title: "CUIL declarado como No Afiliado",
						messageConfirm: `El CUIL ${cuil} ${response[0].surname} ${
							response[0].name
						} fue declarado como No Afiliado, Empresa: ${
							response[0].companyName
						} CUIT: ${response[0].cuit} Periodo: ${response[0].month}/${
							response[0].year
						}`,
						onAccept: () => ""
					});
				} else if (response.affiliateNumber) {
					let msg =
						"Ya existe un afiliado con este CUIL.   Nº Affiliado : " +
						response.affiliateNumber;
					// eslint-disable-next-line
					throw {
						person: {
							cuil: msg
						}
					};
				}
			}
		});
	} else {
		return new Promise(async (resolve, reject) => {
			resolve("");
		});
	}
};

function mapStateToProps(store) {
	const selector = formValueSelector("AfiliadoForm");
	return {
		photoChange: store.afiliado.photoChange,
		firebaseToken: store.app.firebaseToken,
		afiliado: store.afiliado.afiliado,
		provinciasList: store.locations.provinciasList,
		cityList: store.locations.ciudadesList,
		modeCRU: store.afiliado.modeCRU,
		civilStatusList: store.data.civilStatusList,
		gendersList: store.data.gendersList,
		nationalitiesList: store.data.nationalitiesList,
		relationshipList: store.data.relationshipList,
		contributionsList: store.afiliado.contributionsList,
		generateCard: store.afiliado.generateCard,
		rol: store.app.rol,
		cameraPhoto: store.afiliado.cameraPhoto,
		formValues: selector(store, "person.photo", "person.cuil", "status")
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionChangeAfiliadoProps,
			actionGetProvinces,
			actionCreateAfiliado,
			actionUpdateAfiliado,
			actionGetCities,
			actionGetCivilStatusList,
			actionGetGendersList,
			actionGetNationalitiesList,
			actionUploadFile,
			actionDeleteImage,
			actionGetRelationshipList,
			actionGetContributions,
			actionGenerateAffiliateCard,
			asyncCheckCuil,
			actionCheckContriByCUIL
		},
		dispatch
	);
}
export default reduxForm({
	form: "AfiliadoForm",
	asyncValidate,
	onSubmitFail: errors => (errors["family"] ? _handleSubmitFail() : null)
})(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(AfiliadoForm)
);



// WEBPACK FOOTER //
// ./src/screens/Afiliado/AfiliadoForm.js